// FavoritePage.jsx
import React from 'react';
import { Link } from 'react-router-dom';

// The EmptyFavorites component - notice the proper function declaration syntax
const EmptyFavorites = () => {  // Changed from 'export default EmptyFavorites()=>' to 'const EmptyFavorites = () =>'
    return (
      <div className="text-center py-16">
        <div className="w-64 h-64 mx-auto mb-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 400 400"
            className="w-full h-full"
          >
            <path
              d="M200 350c-5.333-4-106.667-82.667-132-132-25.333-49.333-16-107.333 44-132 60-24.667 88 16 88 16s28-40.667 88-16c60 24.667 69.333 82.667 44 132-25.333 49.333-126.667 128-132 132z"
              fill="#FEE2E2"
              stroke="#FCA5A5"
              strokeWidth="8"
            />
            <path
              d="M200 300c-4-3-80-62-99-99-19-37-12-80.5 33-99 45-18.5 66 12 66 12s21-30.5 66-12c45 18.5 52 62 33 99-19 37-95 96-99 99z"
              fill="#FCA5A5"
            />
            <circle cx="200" cy="220" r="20" fill="#F87171" />
            <path
              d="M160 180c-15-15-30-15-45 0M285 180c-15-15-30-15-45 0"
              stroke="#F87171"
              strokeWidth="8"
              strokeLinecap="round"
              fill="none"
            />
          </svg>
        </div>
        <h2 className="text-2xl font-medium text-gray-900 mb-4">Your favorites list is empty</h2>
        <Link to="/" className="bg-[#007D44] text-white px-8 py-3 rounded-full font-medium hover:bg-rose-700 transition-colors">
          Start shopping
        </Link>
      </div>
    );
}

function FavoritePage() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8 max-sm:mt-20">
      <header className="border-b border-gray-200 pb-4">
        <h1 className="text-xl font-medium text-gray-900">Favorites (0)</h1>
      </header>
      
      <EmptyFavorites />
      
      {/* <section className="mt-16">
        <h2 className="text-2xl font-bold text-gray-900 mb-8">More to love</h2>
        <RecommendedProducts />
      </section> */}
    </div>
  );
}

export default FavoritePage;  // Export the main FavoritePage component